/**
 * Data API の URL を取得する
 * @returns {string} Data API の URL
 */
export function getDataApiUrl() {
    // @ts-ignore
    const mtappVars = window.mtappVars;
    let url = '';
    if (typeof mtappVars.DataAPI !== 'undefined') {
        const authUrl = mtappVars.DataAPI.getAuthorizationUrl();
        if (typeof authUrl === 'string') {
            url = authUrl.replace(/(dataapiproxy\.cgi\/v\d+).*$/, '$1');
        }
    } else {
        url = `${mtappVars.dataApiProxyUrl.replace(/\/+$/, '')}/v${mtappVars.dataApiVersion}`;
    }
    if (!url) {
        alert('Data API URL is not set.');
    }
    return url.replace(/\/+$/, '');
}